// roles

const state = {
	roles: [],
	role: {},

};

export default state;